import { Globe, Code2, Keyboard, Printer, Monitor, Home } from "lucide-react";
import ServiceCard from "./ServiceCard";
import { useTranslation } from 'react-i18next';

const ServicesSection = () => {
  const { t } = useTranslation();
  
  const services = [
    {
      title: t('services.webDev.title'),
      description: t('services.webDev.description'),
      features: t('services.webDev.features', { returnObjects: true }) as string[],
      icon: Globe,
      gradient: "bg-gradient-web",
      glowClass: "glow-web",
      textGlowClass: "text-glow-web",
      serviceColor: "hsl(180, 100%, 50%)"
    },
    {
      title: t('services.software.title'),
      description: t('services.software.description'),
      features: t('services.software.features', { returnObjects: true }) as string[],
      icon: Code2,
      gradient: "bg-gradient-software",
      glowClass: "glow-software",
      textGlowClass: "text-glow-software",
      serviceColor: "hsl(120, 100%, 50%)"
    },
    {
      title: t('services.keyboards.title'),
      description: t('services.keyboards.description'),
      features: t('services.keyboards.features', { returnObjects: true }) as string[],
      icon: Keyboard,
      gradient: "bg-gradient-keyboard",
      glowClass: "glow-keyboard",
      textGlowClass: "text-glow-keyboard",
      serviceColor: "hsl(270, 100%, 70%)"
    },
    {
      title: t('services.printing.title'),
      description: t('services.printing.description'),
      features: t('services.printing.features', { returnObjects: true }) as string[],
      icon: Printer,
      gradient: "bg-gradient-3d",
      glowClass: "glow-3d",
      textGlowClass: "text-glow-3d",
      serviceColor: "hsl(30, 100%, 60%)"
    },
    {
      title: t('services.pcBuilding.title'),
      description: t('services.pcBuilding.description'),
      features: t('services.pcBuilding.features', { returnObjects: true }) as string[],
      icon: Monitor,
      gradient: "bg-gradient-pc",
      glowClass: "glow-pc",
      textGlowClass: "text-glow-pc", 
      serviceColor: "hsl(320, 100%, 70%)"
    },
    {
      title: t('services.homeAutomation.title'),
      description: t('services.homeAutomation.description'),
      features: t('services.homeAutomation.features', { returnObjects: true }) as string[],
      icon: Home,
      gradient: "bg-gradient-automation",
      glowClass: "glow-automation",
      textGlowClass: "text-glow-automation",
      serviceColor: "hsl(60, 100%, 60%)"
    }
  ];

  return (
    <section id="services" className="py-20 px-6 relative">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-glow-cyber">
            <span className="bg-gradient-cyber bg-clip-text text-transparent">
              {t('services.title')}
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={service.title} className="animate-slide-in" style={{ animationDelay: `${index * 0.15}s` }}>
              <ServiceCard {...service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;